import { useCallback, useEffect, useState } from "react";

export function useTimeTracker() {
  const [time, setTime] = useState<number>(0);
  const [startTime, setStartTime] = useState<number>(0);

  const startTimer = useCallback(() => {
    if (startTime !== 0) {
      return;
    }
    setStartTime(Date.now());
  }, [startTime]);

  const stopTimer = () => {
    if (startTime === 0) {
      return;
    }
    setStartTime((prevStartTime) => {
      setTime((prevTime) => prevTime + Date.now() - prevStartTime);
      return 0;
    });
  };

  const resetTimer = () => {
    setStartTime(0);
    setTime(0);
  };

  return {
    time,
    startTimer,
    stopTimer,
    resetTimer,
  };
}

// export function useTimeTracker() {
//   const trackedStepMS = 500;
//   const [time, setTime] = useState<number>(0);
//   const [started, setStarted] = useState<boolean>(false);
//   const [timerId, setTimerId] = useState<number>(0);
//
//   const startTimer = useCallback(() => {
//     if (started) {
//       return;
//     }
//     setStarted(true);
//   }, [started]);
//
//   useEffect(() => {
//     if (started && timerId === 0) {
//       const id = window.setInterval(() => {
//         setTime((prevTime) => prevTime + trackedStepMS);
//       }, trackedStepMS);
//       setTimerId(id);
//     }
//
//     if (!started && timerId !== 0) {
//       clearInterval(timerId);
//       setTimerId(0);
//     }
//
//     return () => clearInterval(timerId);
//   }, [started, timerId]);
//
//   const stopTimer = () => {
//     setStarted(false);
//   };
//
//   const resetTimer = () => {
//     setStarted(false);
//     setTime(0);
//   };
//
//   return {
//     time,
//     startTimer,
//     stopTimer,
//     resetTimer,
//   };
// }
